import { DashboardOutlined, PictureOutlined } from '@ant-design/icons'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import CIMSLink from 'components/CIMSLink'
import { useEffect, useState } from 'react'
import { useProjectContext } from 'context/ProjectContext'
import { getPhotoViewerHref } from './getPhotoViewerHref'

export function useExternals(): ItemType[] {
  const {
    projectName,
    sharePoint: { sharePointURL: spURL, sharePointSiteURL: spSiteURL },
  } = useProjectContext()
  const [sharePointUrl, setSharePointUrl] = useState<string | null>()
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setSharePointUrl(spURL ?? spSiteURL)
    return () => {
      setSharePointUrl(undefined)
    }
  }, [spURL, spSiteURL])
  return [
    {
      key: 'sharepoint',
      icon: <DashboardOutlined />,
      label: (
        <CIMSLink
          external
          href={sharePointUrl}
          tooltip={
            !sharePointUrl
              ? `There doesn't appear to be a SharePoint site associated with ${
                  projectName ?? 'this project'
                }`
              : undefined
          }
        >
          SharePoint
        </CIMSLink>
      ),
    },
    {
      key: 'photoViewer',
      icon: <PictureOutlined />,
      label: (
        <CIMSLink
          external
          href={getPhotoViewerHref(projectName)}
          tooltip={
            !projectName
              ? 'Unable to link to the Photo Viewer for this project'
              : undefined
          }
        >
          Photo Viewer
        </CIMSLink>
      ),
    },
  ]
}
